import Ajax from '@utils/ajax';

export default {
  fetch(group, data = {}, options = {}) {
    return Ajax.get({
      url: `/groups/${group.id}/sections`,
      data,
      ...options,
    });
  },

  create(group, data) {
    return Ajax.post({
      url: `/groups/${group.id}/sections`,
      data: {
        section: data,
      },
    });
  },

  destroy(group, section, data, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/sections/${section.id}`,
      data: { ...data, _method: 'DELETE' },
      ...options,
    });
  },

  update(group, section, data) {
    return Ajax.post({
      url: `/groups/${group.id}/sections/${section.id}`,
      data: {
        _method: 'PATCH',
        section: data,
      },
    });
  },

  changeSortOrder(group, ids) {
    return Ajax.post({
      url: `/groups/${group.id}/sections/change_sort_order`,
      data: {
        sort_order: ids,
      },
    });
  },
};
